import { render, staticRenderFns } from "./PartnerInvitationList.vue?vue&type=template&id=85f6a172"
import script from "./PartnerInvitationList.vue?vue&type=script&lang=js"
export * from "./PartnerInvitationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports